import { api } from './client'

export const listAuditLogs = async ({ actor, action, object_type, object_id, start, end, q, limit } = {}) => {
  const params = {}
  if (actor) params.actor = actor
  if (action) params.action = action
  if (object_type) params.object_type = object_type
  if (object_id) params.object_id = object_id
  if (start) params.start = start
  if (end) params.end = end
  if (q) params.q = q
  if (limit) params.limit = limit
  const { data } = await api.get('/audit/logs', { params })
  return data
}

